import { useEffect, useState } from 'react';

export const useDimensions = () => {
  const [widthD, setWidthD] = useState(window.innerWidth);
  const [heightD, setHeightD] = useState(window.innerHeight);

  const updateDimensions = () => {
    setWidthD(window.innerWidth);
    setHeightD(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return { widthD, heightD };
};
